export default "__VITE_ASSET__BoOuEf$Q__"